module.exports = {
  url: '/work/:slug:service',
  template: require('raw!templates/work/work.html'),
  controller: ['$scope', '$state', 'store', 'contentful', '$uibModal', '$window', '$sce', component],
  params: {
    service: {
        value: '',
        squash: true
      },
    slug: {
        value: '',
        squash: true
      }
  }
}

function component ($scope, $state, store, contentful,  $uibModal, $window, $sce, slug) {

  $scope.pageClass = 'page-work';
  $scope.allWorkServicesProvided = []
  var vm = this;

  if(store.get('selectedWorkService')) {
    $scope.selectedWorkService = store.get('selectedWorkService')
  } else {
    $scope.selectedWorkService = 'Building Enclosure'
  }
  $scope.setWorkService = function (workService) {
    if(workService){
      store.set('selectedWorkService', workService)
    } else {
      store.set('selectedWorkService', $scope.defaultWorkService)
    }
  }
  function comparePriority(a,b) {
  if (a.fields.priority < b.fields.priority)
    return -1;
  if (a.fields.priority > b.fields.priority)
    return 1;
  return 0;
  }
  contentful.entries('content_type=workProjects&include=3').then(function(res) {
    var workProjects = res.data.items
    $scope.allWorkProjects = res.data.items
    angular.forEach(workProjects, function(workProject){
      if(workProject.fields.services){
        var services = workProject.fields.services
        angular.forEach(services, function(service) {
          if(service.fields){
            var index = $scope.allWorkServicesProvided.indexOf(service)
            if (index < 0) {
              $scope.allWorkServicesProvided.push(service)
              $scope.allWorkServicesProvided.sort(comparePriority)
              $scope.defaultWorkService = $scope.allWorkServicesProvided[0]
              store.set('defaultWorkService', $scope.defaultWorkService)
            }
          }
        })
      }
    })
  })

  if($state.params.service) {
    $scope.page = $state.params.service
    $scope.currentServiceProvided = $state.params.service
    if($state.params.service.fields.pageTitle) {
      $scope.selectedService = $state.params.service.fields.pageTitle
    }
    $scope.serviceDesc = $state.params.service.fields.pageSpecificMetaDescriptionSeo

    store.set('workService', $scope.selectedService)
    // console.log('selected service',  $scope.selectedService );
  } else if(store.get('selectedWorkService')){
    $scope.currentServiceProvided = store.get('selectedWorkService')
    $scope.selectedService = $scope.currentServiceProvided.fields.pageTitle
    $scope.serviceDesc = $scope.currentServiceProvided.fields.pageSpecificMetaDescriptionSeo

  }

  $scope.trustSrc = function(src) {
return $sce.trustAsResourceUrl(src);
}

  $window.scrollTo(0,0);

  $scope.slide = {
    'workNav' : true
  }

  contentful.entries('content_type=serviceTypes').then(function(res) {
    var seoData = res.data.items[0];
      document.title = $scope.selectedService;

    if (seoData.fields.pageSpecificMetaDescriptionSeo) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = $scope.serviceDesc ;
        }
      }
    }
  });

  $scope.selectServiceProvided = function (serviceProvided) {
    // console.log('serviceProvided', serviceProvided);
    $scope.currentServiceProvided = serviceProvided
    $scope.page = $scope.currentServiceProvided
  }

//// below needed for service subnav to display///////
  $scope.allServices = []
  contentful.entries('content_type=serviceTypes').then(function(res) {
    var items = res.data.items
    angular.forEach(items, function(item){
      $scope.allServices.push(item)
    })
   })
  $scope.selectService = function (service) {
    $scope.currentService = service
    $scope.page = $scope.currentService.fields.pageTitle
  }
  $scope.allWorkProjects = []
  contentful.entries('content_type=workProjects&include=3').then(function(res) {
    $scope.allWorkProjects = res.data.items
  })
}



/** WEBPACK FOOTER **
 ** ./components/templates/work/work.js
 **/